import { useEffect, useRef } from 'react'

import {
  episodeHouseId,
  navigationGa,
  seasonHouseId,
  seriesTitleHouseId
} from '../lib/analytics/ga'
import {
  dataLayerProductDetail,
  getAdditionalGenreFromContentItem
} from '../lib/analytics/datalayer'
import { customDimensions } from '../lib/analytics/custom-dimensions'
import { useProfile } from './use-profile'

function useTrackShowPageSideEffects({
  contentItem,
  componentName
}) {
  const { currentProfile, loading: profileLoading } = useProfile('cache-only')
  const lastTrackingKeyRef = useRef(null)

  useEffect(() => {
    if (!contentItem || profileLoading) {
      return
    }

    // Dedupe: only run if contentItem changed
    if (lastTrackingKeyRef.current === contentItem.id) {
      return
    }
    lastTrackingKeyRef.current = contentItem.id
    dataLayerProductDetail(contentItem)
    navigationGa({
      action: 'showPage',
      label: contentItem.title,
      [customDimensions.ShowTitle]: contentItem.title,
      [customDimensions.ProfileId]: currentProfile?.id,
      [customDimensions.ProfileName]: currentProfile?.name,
      [customDimensions.SeasonNumber]: contentItem.seasonNumber,
      [customDimensions.EpisodeNumber]: contentItem.episodeNumber,
      [customDimensions.AdditionalGenre]: getAdditionalGenreFromContentItem(contentItem),
      [customDimensions.SeriesTitleHouseId]: seriesTitleHouseId(contentItem),
      [customDimensions.SeasonHouseId]: seasonHouseId(contentItem),
      [customDimensions.EpisodeHouseId]: episodeHouseId(contentItem),
      [customDimensions.ComponentName]: componentName
    })
  }, [
    componentName,
    contentItem,
    currentProfile,
    profileLoading
  ])
}

export default useTrackShowPageSideEffects
